//
//
//
//
//
//

export default {
  props: {
    height: {
      type: Number,
      required: false,
      default: 1
    }
  }
}
